export const AppString = {
    USERS_DOC_REALTIME_DB: "usersTable",
    DEFAULT_AVATAR: "https://cdn2.iconfinder.com/data/icons/ios-7-icons/50/user_male2-512.png",
    USER_STATUS: "user_status",
    USERINCALL_STATUS: "userInCall_status",

    ROOMS_LIST: "roomsList",
    MEMBERS_LIST: "membersList",
    ROOM_MESSAGES: "roomMessages",
    ROOM_METADATA: "roomMetadata",
    USER_NOTIFICATION: "userNotification",
    ROOM_TYPING_INDICATOR: "roomTypingStatus",
    INCALL_UserPresence : "IncallPresence",
    ADMIN_ACCESS_DOC: "adminAccess",

    Dailyco_Col: 'dailyco',
}